import { Button, Typography } from '@mui/material'
import { useEffect, useRef, useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { Dialog } from '@app/components/dialogs'
import { useKnowledgeHubUrl } from '@app/hooks/useKnowledgeHubUrl'

export const isNotTargetPage = (pathname: string) => {
  const cleanPath = pathname.replace(/\/$/, '')
  const pathParts = cleanPath.split('/').filter(Boolean)

  if (
    pathParts.length === 1 &&
    [
      'accept-invite',
      'accept-org-invite',
      'auto-login',
      'invitation',
      'login',
      'onboarding',
      'org-invitation',
      'registration',
      'verify',
    ].includes(pathParts[0])
  ) {
    return true
  }

  return false
}

type KnowledgeHubCourseInviteSplashScreenProps = {
  onSubmit: () => void
}

export const KnowledgeHubCourseInviteSplashScreen = ({
  onSubmit,
}: KnowledgeHubCourseInviteSplashScreenProps) => {
  const { t } = useTranslation()

  const hasDialogOpened = useRef<boolean>(false)
  const [open, setOpen] = useState(true)

  useEffect(() => {
    if (open && !hasDialogOpened.current) {
      hasDialogOpened.current = true
    }
  }, [open])

  // Record the submission as soon as the pop-up is dismissed (via the Access
  // button or the close button) so it is shown only once (AC5/AC6).
  useEffect(() => {
    if (!open && hasDialogOpened.current) {
      onSubmit()
    }
  }, [onSubmit, open])

  const knowledgeHubUrl = useKnowledgeHubUrl()

  return (
    <Dialog
      data-testid="knowledge-hub-splash-screen"
      open={open}
      onClose={(_event, reason) => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
          return
        }
        setOpen(false)
      }}
      slots={{
        Title: () => (
          <Typography
            variant="h3"
            fontWeight={600}
            color="secondary"
            gutterBottom
            textAlign="center"
          >
            {t('components.knowledge-hub-splash-screen.title')}
          </Typography>
        ),
      }}
    >
      <Typography variant="body1" paragraph>
        <Trans
          i18nKey="components.knowledge-hub-splash-screen.body"
          components={{ b: <b />, br: <br /> }}
        />
      </Typography>

      <Button
        data-testid="knowledge-hub-splash-screen-access"
        color="lime"
        variant="contained"
        size="large"
        fullWidth
        href={knowledgeHubUrl}
        target="_blank"
        rel="noopener"
        onClick={() => {
          setOpen(false)
        }}
        sx={{ my: 2 }}
      >
        {t('components.knowledge-hub-splash-screen.access-button')}
      </Button>

      <Typography fontWeight={600}>
        {t('components.knowledge-hub-splash-screen.footer')}
      </Typography>
    </Dialog>
  )
}
